// Testing urls
// chart: http://localhost:3000/asset/chart?fc7acca1-6381-4052-8aeb-d46d7e13e76c:W283:Omega105-012:true:IntcInN0eWxlT3ZlcnJpZGVzXCI6e1wibGVnZW5kXCI6e1wic2hvd1wiOnRydWUsXCJ0ZXh0U3R5bGVcIjp7fX19LFwiY2hhcnRUaXRsZVwiOlwiXCIsXCJzZWxlY3RlZEl0ZW1zXCI6W3tcInJlcG9ydFNlcmllc1RhYmxlSURcIjpcIkkxNDQzXzI5NTg3NDIyMjRcIixcImtwaVwiOlwiT3Bwb3J0dW5pdHkgQ291bnQgYnkgQ3JlYXRlZCBEYXRlXCJ9LHtcInJlcG9ydFNlcmllc1RhYmxlSURcIjpcIkkxNDQzXzI5NTg3NDIyMjRcIixcImtwaVwiOlwiVG90YWwgUmV2ZW51ZSBieSBDbG9zZSBEYXRlXCJ9XSxcInNlbGVjdGVkRGF0ZXNcIjp7fSxcInN0YWNrZWRcIjpmYWxzZSxcImRyaWxsQXR0cmlidXRlXCI6bnVsbCxcImNhdGVnb3J5QXhpc1wiOlwiTGVhZCBTb3VyY2VcIixcInNvcnRDb2x1bW5zXCI6W3tcImNvbHVtblwiOlwiVG90YWwgUmV2ZW51ZVwiLFwib3JkZXJcIjpcImRlc2NcIn1dLFwicGVyaW9kXCI6XCJNb250aGx5XCIsXCJjYWxlbmRhclR5cGVcIjpcIkNhbGVuZGFyXCIsXCJ2aWV3XCI6XCJjaGFydFwiLFwiZGlzcGxheVJvd3NcIjpcIkFsbFwiLFwiZGlzYWJsZVRpbWVTZXJpZXNcIjpmYWxzZSxcInVzZWREcmlsbEF0dHJpYnV0ZXNcIjpbXSxcInNlcmllc1R5cGVcIjpcImhlYXRtYXBcIixcImtwaUNvbXBhcmVUeXBlXCI6XCJwZXJjZW50YWdlXCIsXCJiYWNrd2FyZHNGbGFnXCI6XCIyLjEuOFwiLFwiZmlsdGVyXCI6e1wiYm9wZXJhdG9yXCI6XCJBbmRcIixcImZpbHRlcnNcIjpbe1widGFibGVRdWFsaWZpZXJcIjpudWxsLFwiYXR0cmlidXRlTmFtZVwiOlwiU3RhZ2VcIixcImFnZ3JlZ2F0aW9uUnVsZVwiOm51bGwsXCJvcGVyYXRvclwiOlwiRXF1YWxzXCIsXCJmaWx0ZXJWYWx1ZVwiOntcInZhbHVlc1wiOltcIkNsb3NlZCBXb25cIl19fSx7XCJ0YWJsZVF1YWxpZmllclwiOm51bGwsXCJhdHRyaWJ1dGVOYW1lXCI6XCJMZWFkIFNvdXJjZVwiLFwiYWdncmVnYXRpb25SdWxlXCI6bnVsbCxcIm9wZXJhdG9yXCI6XCJOb3RFcXVhbHNcIixcImZpbHRlclZhbHVlXCI6e1widmFsdWVzXCI6W1wiTm9uZVwiLFwiXCJdfX1dfSxcInRpdGxlXCI6XCJMZWFkIFNvdXJjZSBQZXJmb3JtYW5jZSBIZWF0bWFwXCJ9Ig==
// cluster: http://localhost:3000/asset/cluster?fc7acca1-6381-4052-8aeb-d46d7e13e76c:W283:Omega105-012:true:W3siY2x1c3RlcklEIjoiY2x1c3Rlcl8wIiwiY2x1c3Rlck5hbWUiOiJMb3cgUHJvYmFiaWxpdHksIExvdyBWYWx1ZSBPcHBvcnR1bml0aWVzIiwiY291bnQiOjMyMDg2fSx7ImNsdXN0ZXJJRCI6ImNsdXN0ZXJfMSIsImNsdXN0ZXJOYW1lIjoiSGlnaCBQcm9iYWJpbGl0eSBhbmQgUmV2ZW51ZSBQaXBlbGluZSIsImNvdW50IjoxNDQ4NH1d
// tree: http://localhost:3000/asset/tree?fc7acca1-6381-4052-8aeb-d46d7e13e76c:W283:Omega105-012:true:eyJuYW1lIjoiRXhwZWN0ZWQgQW1vdW50IiwiY2hpbGRyZW4iOlt7Im5hbWUiOiJUeXBlIiwiZWRnZUxhYmVsIjoiPD0gMCJ9LHsibmFtZSI6Ik5ldy9VcHNlbGwvRXhwYW5zaW9uIEFtb3VudCIsImVkZ2VMYWJlbCI6Ij4gMCJ9XSwibnVtTm9kZXMiOjIzNSwibGV2ZWxTaXplcyI6WzEsMiwyNSw0MSwzMyw0OSw1MiwxNCwxNiwyXX0=

import { useEffect, useRef, useState } from 'react'
import styles from './Asset.module.scss'
import { Outlet } from 'react-router-dom'
import { Server } from '../../../api/Server'
import { useAssetParams } from '../../../hooks/useAssetParams'

export const Asset = () => {
    const { params, route } = useAssetParams()
    const [server, setServer] = useState(null)
    const [workspaceMetadata, setWorkspaceMetadata] = useState(null)
    const containerRef = useRef()

    useEffect(() => {
        if (params && params.userID && params.workspaceID && params.invite) {
            const newServer = new Server(params.workspaceID, params.userID, params.invite)
            newServer.postData(
                {
                    action: 'getWorkspaceMetadata',
                },
                (result) => {
                    setWorkspaceMetadata(result)
                    setServer(newServer)
                }
            )
        }
    }, [params])

    const shouldRenderOutlet = () => {
        switch (route) {
            case 'chart':
                return server && workspaceMetadata && containerRef.current
            case 'cluster':
                return true
            case 'tree':
                return true
            default:
                return false
        }
    }

    return (
        <div className={styles.container} ref={containerRef}>
            {shouldRenderOutlet() ? (
                <Outlet
                    context={{
                        server,
                        workspaceMetadata,
                        containerSize: {
                            height: containerRef.current.clientHeight,
                            width: containerRef.current.clientWidth,
                        },
                    }}
                />
            ) : null}
        </div>
    )
}
